import React, { useState, useEffect } from "react";
import SeasonList from "./SeasonList";
import { ExportJsonCsv } from "react-export-json-csv";
import { Container, Row, Col, Form } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LocationNotes from "./LocationNotes";

import { apiEndpoint } from '../config/api';
import { getTrackingYears } from '../config/seasons';

export default function Season(props) {
  const filename = "Csv-file" + new Date().toISOString().slice(0, 10);
  const headers = [
    { key: "sKey", name: "sKey" },
    { key: "comCode", name: "comCode" },
    { key: "comID", name: "comID" },
    { key: "facilityName", name: "facilityName" },
    { key: "seasonID", name: "seasonID" },
    { key: "seasonName", name: "seasonName" },
    { key: "seasonDateS", name: "seasonDateS" },
    { key: "seasonDateE", name: "seasonDateE" },
    { key: "seasonDesc", name: "seasonDesc" },
    { key: "priorYearSeasonId", name: "priorYearSeasonId" },
    { key: "priorYearSeasonName", name: "priorYearSeasonName" },
    { key: "ProgramType", name: "ProgramType" },
    { key: "TrackingSeason", name: "TrackingSeason" },
    { key: "TrackingYear", name: "TrackingYear" },
    { key: "emailList", name: "emailList" },
    { key: "added", name: "added" },
    { key: "accepted", name: "accepted" },
  ];

  const comcodes = props.comcodes;

  const [seasonsArray, setSeasonsArray] = useState([]);
  const [isInAsynch, setisInAsynch] = useState(false);
  const [seasonTrackFilter, setSeasonTrackFilter] = useState(["3"]);
  const [yearTrackFilter, setYearTrackFilter] = useState([String(new Date().getFullYear())]);
  const [lkCount, setLKCount] = useState(0);
  const [siCount, setSICount] = useState(0);

  const seasonDataForQueries = props.seasonDataForQueries;

  function filterBy(seasonObj) {
    if (
      (seasonTrackFilter.length !== 0 &&
        !seasonTrackFilter.includes(seasonObj.trackingSeason)) ||
      (yearTrackFilter.length !== 0 &&
        !yearTrackFilter.includes(seasonObj.trackingYear))
    ) {
      return false;
    } else {
      return true;
    }
  }

  // const filteredSeasonsArray = seasonsArray.filter(filterBy);

  useEffect(() => {
    const tempfunction = async () => {
      const filteredSeasonsArray = seasonDataForQueries.filter(filterBy);
      setSeasonsArray(filteredSeasonsArray);
    };

    tempfunction();
  }, [seasonDataForQueries, seasonTrackFilter, yearTrackFilter]);

  const handleChangeSeasonTrack = (event) => {
    const {
      target: { value },
    } = event;
    setSeasonTrackFilter(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangeYearTrack = (event) => {
    const {
      target: { value },
    } = event;
    setYearTrackFilter(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleUpdateDates = () => {
    const filteredSeasonsArray = seasonDataForQueries.filter(filterBy);
    setSeasonsArray(filteredSeasonsArray);
  };

  const handleLKCountUpdate = (count) => {
    setLKCount(count);
  };

  const handleSICountUpdate = (count) => {
    setSICount(count);
  };

  const seasonTrack = [
    {
      id: "1",
      value: "Spring",
    },
    {
      id: "2",
      value: "Summer",
    },
    {
      id: "3",
      value: "Fall",
    },
    {
      id: "4",
      value: "Winter",
    },
  ];

  const yearTrack = getTrackingYears();

  const totalRows = seasonsArray.length;
  const lkRows = seasonsArray.filter(r => Number(r.ProgramType) === 1).length;
  const siRows = seasonsArray.filter(r => Number(r.ProgramType) === 2).length;
  const otherRows = totalRows - lkRows - siRows;

  // const classes = useStyles();
  // const isSmallScreen = useMediaQuery('(max-width: 3000px)');

  return (
    // <div className={isSmallScreen ? classes.cardsLayout : classes.tableLayout}>
      <Container fluid>
        <Box sx={{ mt: 2, mb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Browse and review current season status by tracking period.
          </Typography>
        </Box>
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Grid container alignItems="center" justify="center">
          <Grid item md={6}>
            <p></p>
            <>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={seasonTrackFilter}
                onChange={handleChangeSeasonTrack}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) =>
                  selected.map((obj) => seasonTrack[obj - 1].value).join(", ")
                }
              >
                {seasonTrack.map((season) => (
                  <MenuItem key={season.id} value={season.id}>
                    <Checkbox
                      checked={seasonTrackFilter.indexOf(season.id) > -1}
                    />
                    <ListItemText primary={season.value} />
                  </MenuItem>
                ))}
              </Select>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={yearTrackFilter}
                onChange={handleChangeYearTrack}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => selected.join(", ")}
              >
                {yearTrack.map((year) => (
                  <MenuItem key={year} value={year}>
                    <Checkbox checked={yearTrackFilter.indexOf(year) > -1} />
                    <ListItemText primary={year} />
                  </MenuItem>
                ))}
              </Select>
            </>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => handleUpdateDates(e)}
            >
              Refresh
            </Button>
          </Grid>

          <Grid item md={2}>
            <p></p>
            {isInAsynch ? <CircularProgress /> : <></>}
          </Grid>

          <Grid item md={1}>
            <p className="count">
              <b>LK: {lkCount}</b>
              {/* <b>LK: </b> */}
            </p>
          </Grid>
          <Grid item md={1}>
            <p className="count">
              <b>SI: {siCount}</b>
              {/* <b>SI: </b> */}
            </p>
          </Grid>

          <Grid item>
            <p></p>
            <ExportJsonCsv
              className="btn btn-primary"
              headers={headers}
              items={seasonsArray}
              fileTitle={filename}
            >
              DownLoad CSV
            </ExportJsonCsv>
          </Grid>
        </Grid>
        </Paper>
        <Box sx={{ display: 'flex', gap: 3, mb: 1, px: 0.5 }}>
          <Typography variant="body2"><strong>Total:</strong> {totalRows}</Typography>
          <Typography variant="body2"><strong>LK:</strong> {lkRows}</Typography>
          <Typography variant="body2"><strong>SI:</strong> {siRows}</Typography>
          <Typography variant="body2"><strong>Other:</strong> {otherRows}</Typography>
        </Box>
        <hr></hr>

        <Grid>
          <Grid>
            <SeasonList
              seasonsArray={seasonsArray}
              comcodes={comcodes}
              seasonDataForQueries={seasonDataForQueries}
              handleLKCountUpdate={handleLKCountUpdate}
              handleSICountUpdate={handleSICountUpdate}
            />
          </Grid>
        </Grid>
      </Container>
    // </div>
  );
}
